import { useRef, useCallback, useEffect, useState } from 'react-x';
import _isFunction from 'lodash/isFunction.js';

export function useDragScroll({speed, onScrollCallback} = {}) {

  const startPoint = useRef(null);
  const scrollLeft = useRef(0);
  const isMouseDown = useRef(false);
  const [scrollPosition, setScrollPosition] = useState('start');
  const activeSrcollClassname = 'drag-scrolling-active';

  const onStart = useCallback(e => {
    const scrollableEl = e.currentTarget;
    isMouseDown.current = true;
    startPoint.current = e.pageX - scrollableEl.offsetLeft;
    scrollLeft.current = scrollableEl.scrollLeft;
  });

  const onMove = useCallback(e => {
    e.preventDefault();
    if (isMouseDown.current) {
      const scrollableEl = e.currentTarget;
      const xPosition = e.pageX - scrollableEl.offsetLeft;
      const moveDistance = (xPosition - startPoint.current) * (speed || 1);
      scrollableEl.classList.add(activeSrcollClassname);
      setScrollPosition(getScrollPosition(scrollableEl));
      scrollableEl.scrollLeft = scrollLeft.current - moveDistance;
    }
  });

  const touchMove = useCallback(e => {
    setScrollPosition(getScrollPosition(e.currentTarget));
  });

  function getScrollPosition(el) {
    const end = (el.scrollLeft + el.offsetWidth) >= el.scrollWidth - 5;
    const start = el.scrollLeft === 0;
    const scrollPosition = start ? 'start' : end ? 'end' : 'middle';
    return scrollPosition;
  };

  useEffect(() => {
    if (_isFunction(onScrollCallback)) {
      onScrollCallback(scrollPosition);
    }
  }, [scrollPosition]);

  const onEnd = useCallback(e => {
    const scrollableEl = e.currentTarget;
    scrollableEl.classList.remove(activeSrcollClassname);
    isMouseDown.current = false; 
  });

  const mouseEvents = {
    onMouseMove: onMove,
    onMouseDown: onStart,
    onMouseUp: onEnd,
    onMouseLeave: onEnd,
    onTouchMove: touchMove
  };

  return mouseEvents;
};